import React, { useState, useEffect, useMemo } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftAvatar from "components/SoftAvatar";
import swal from "sweetalert2";
import bruce from "assets/images/bruce-mars.jpg";
import { api } from "utils/Api";
// import EditFormPopup from "layouts/admin/user/data/EditForm";
import DeleteForm from "layouts/admin/Organization/DeleteForm";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SmartTableCard from "utils/Smart Table/SmartTableCard";
import ConciergeAddToUnit from "./AdminConciergeAddToProperties";
import EditFormPopup from "layouts/admin/user/data/EditForm";
import { useParams } from "react-router-dom";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { Box, Tooltip } from "@mui/material";
import AdminConciergeAddToProperty from "./AdminConciergeAddToProperties";
import { getSecureItem } from "utils/SecureStorage";
import RemoveFromParentForm from "layouts/admin/Organization/MultipleDeleteForm";
import { showSuccess } from "utils/messageAlerts";
import { canUpdate } from "utils/permissionManager";
import { canDelete } from "utils/permissionManager";
import { canCreate } from "utils/permissionManager";
import { useHierarchy } from "context/HierarchyContext";
import { useAuth } from "context/AuthContext";
import RestoreIcon from "@mui/icons-material/Restore";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ConfirmDialog from "utils/ConfirmDialog";
import MultiConfirmDialog from "utils/MultiConfirmDialog";

function AdminConcierge() {
  const [concierge, setConcierge] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [ property, setProperty ] = useState([]);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isAddPopupOpen, setIsAddPopupOpen] = useState(false);
  const [selectedConcierge, setSelectedConcierge] = useState(null);
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);
  const currentOrgId = JSON.parse(getSecureItem("currentUser"))?.organization_id;
  const roleId = JSON.parse(getSecureItem("currentUser"))?.role_id;
  const [propertyFilterAnchor, setPropertyFilterAnchor] = useState(null);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [propertySearch, setPropertySearch] = useState("");
  const { propertyId, orgId  } = useHierarchy();
  const { isAdmin, isManager } = useAuth();
  const current_user_role_id = getSecureItem("role_id");
  const [confirmDialog, setConfirmDialog] = useState({
  open: false,
  type: null,
  concierge: null,
  property: null
});
  
  useEffect(() => {
    fetchProperties();
  }, []);

  useEffect(() => {
    fetchConcierge();
  }, [propertyId]);

  // Fetch all users, then filter only role_id === 3 (Concierge)
  const fetchConcierge = async () => {
    let role_id = 4; // Concierge role_id
    let userApi;

    try {
      if (!propertyId) {
        userApi = await api.user.getFiltertedUser({ role_id, organization_id: parseInt(orgId) || currentOrgId, current_user_role_id });
      } else {
        userApi = await api.user.getFiltertedUserByProperty({ role_id, organization_id: parseInt(orgId) || currentOrgId, property_id: propertyId, current_user_role_id });
      }
      const userData = userApi;
      const formatted = userData.map((u) => ({
        
        id: u.id,
        username: u.username,
        first_name: u.first_name,
        last_name: u.last_name,
        email: u.email,
        phone_number: u.phone_number,
        description: u.description,
        active: u.active,
        image: u.image || null,
        organization_id: u.organization_id,
        role_id: u.role_id,
        createdAt: u.created_at,
        property_id: u.property_id,
        user_property: u.user_property || [],
      }));

      setConcierge(formatted);
    } catch (e) {
      setConcierge([]);
    }
  };

  const fetchProperties = async () => {
    try {
      const payload = {
        organization_id: orgId || currentOrgId, current_user_role_id
      }
      const propertyData = await api.properties.getProperties(payload);
      setProperty(propertyData);
    } catch (e) {
    }
  };

  // Edit Concierge
  const handleEditConcierge = (concierge) => {
    setSelectedConcierge(concierge);
    setIsEditPopupOpen(true);
  };

  // Delete Concierge
  const handleDeleteConcierge = async (payload) => {
    try { 

    await api.userProperty.deleteUserProperty(payload);

      showSuccess("Concierge removed from property successfully");

      fetchConcierge();
    } catch (err) {
    
    }
  };

  // Search Concierge
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const filteredConcierge = concierge.filter((concierge) => {
    const term = searchTerm.toLowerCase();

    const matchesSearch =
      !searchTerm.trim() ||
      concierge.first_name?.toLowerCase().includes(term) ||
      concierge.last_name?.toLowerCase().includes(term) ||
      concierge.email?.toLowerCase().includes(term) ||
      concierge.username?.toLowerCase().includes(term);

    const matchesConcierge =
      selectedProperties.length === 0 ||
      concierge.user_property?.some((up) => selectedProperties.includes(up.property_id));

    return matchesSearch && matchesConcierge;
  });

  const filteredPropertyList = property
    .filter((p) => p.organization_id === Number(orgId))
    .filter((p) => p.name.toLowerCase().includes(propertySearch.toLowerCase()));

  const propertyMap = useMemo(() => {
    const map = {};
    property.forEach((p) => {
      map[p.id] = p.name;
    });
    return map;
  }, [property]);

  const canEdit = canUpdate("User Property");
  const canRemove = canDelete("User Property");
  const showActionsColumn = canEdit || canRemove;

  const handleConciergeActionClick = (user, action) => {
  setConfirmDialog({
    open: true,
    type: action,
    user,
  });
};

  const handleConfirmAction = async (property_id) => {
    const { concierge, type } = confirmDialog;

    if (!property_id) return;

    const payload = {
      property_id,
      user_id: concierge.id,
      user_role_id: 4,
      organization_id: orgId || currentOrgId,
    };

    try {
      if (type === "delete") {
        await api.userProperty.deleteUserPropertyHard(payload);
        showSuccess("Concierge permanently deleted successfully");
      } else {
        await api.userProperty.restoreUserProperty({
          property_id,
          user_id: concierge.id,
          organization_id: orgId || currentOrgId,
          current_user_role_id: roleId,
        });
        showSuccess("Concierge restored successfully");
      }

      fetchConcierge();
    } catch (e) {}

    setConfirmDialog({ open: false, type: null, concierge: null, property: null });
  };

  return (
    <SmartTableCard
      title={`All Concierge`}
      headerRight={[
        canCreate("User Property") && (
          <SoftButton
            key="add-btn"
            variant="outlined"
            color="info"
            size="small"
            onClick={() => setIsAddPopupOpen(true)}
          >
            Add Concierge
          </SoftButton>
        ),
        <SoftInput
          key="search-input"
          placeholder="Search Concierge"
          value={searchTerm}
          onChange={handleSearch}
          size="small"
        />,
      ]}
      columns={[
        { label: "Username", key: "Username", align: "center" },
        { label: "Email", key: "Email", align: "center" },
        { label: "Phone", key: "Phone", align: "center" },
        { label: "Description", key: "Description", align: "center" },
        {
          label: (
            <SoftBox display="flex" alignItems="center" justifyContent="center" gap="4px">
              <span>Property</span>

              <SoftBox position="relative" display="flex" alignItems="center">
                <FilterAltOutlinedIcon
                  fontSize="small"
                  sx={{
                    cursor: "pointer",
                    color: selectedProperties.length ? "#0284C7" : "#475467",
                    "&:hover": { color: "#0284C7" },
                  }}
                  onClick={(e) => setPropertyFilterAnchor(e.currentTarget)}
                />

                {selectedProperties.length > 0 && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: -4,
                      right: -6,
                      background: "#0284C7",
                      color: "#fff",
                      borderRadius: "50%",
                      fontSize: 10,
                      width: 16,
                      height: 16,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {selectedProperties.length}
                  </Box>
                )}
              </SoftBox>
            </SoftBox>
          ),
          key: "Property",
          align: "center",
        },
        ...(isAdmin || isManager ? [{ label: "Active", key: "Active", align: "center" }] : []),
        ...(showActionsColumn ? [{ label: "Actions", key: "Actions", align: "center" }] : []),
      ]}
      rows={filteredConcierge.map((concierge) => {
        const validUserProperties = (concierge.user_property || []).filter(
          (uu) => propertyMap?.[uu.property_id]
        );

        const isActive = validUserProperties.some((uu) => uu.active === true);
        const isInactive = !isActive;

        return {
          Username: concierge.username,
          Email: concierge.email,
          Phone: concierge.phone_number,
          Description: concierge.description,
          Property: (() => {
            if (!concierge.user_property?.length) return "N/A";

            const propertyNames = concierge.user_property
            .filter((up) => up.user_id === concierge.id)
            .map((up) => propertyMap[up.property_id])
            .filter(Boolean);
            return propertyNames.length ? propertyNames.join(", ") : "N/A";
          })(),
          ...(isAdmin || isManager
            ? {
                Active: (() => {
                  const inactiveProperty = concierge.user_property?.find(
                    (uu) => uu.active === false
                  );
                  const activeProperty = concierge.user_property?.find((uu) => uu.active === true);

                  if (inactiveProperty) {
                    return (
                      <SoftBox display="flex" justifyContent="center" gap="6px">
                        <Tooltip title="Restore Concierge" arrow>
                          <IconButton
                            onClick={() =>
                              setConfirmDialog({
                                open: true,
                                type: "restore",
                                concierge,
                                property: inactiveProperty,
                              })
                            }
                            sx={{ color: "#16A34A" }}
                          >
                            <RestoreIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Delete Permanently" arrow>
                          <IconButton
                            onClick={() =>
                              setConfirmDialog({
                                open: true,
                                type: "delete",
                                concierge,
                                property: inactiveProperty,
                              })
                            }
                            sx={{ color: "#DC2626" }}
                          >
                            <DeleteForeverIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </SoftBox>
                    );
                  }

                  if (activeProperty) {
                    return (
                      <SoftTypography variant="button" color="success" fontWeight="bold">
                        Yes
                      </SoftTypography>
                    );
                  }

                  return "N/A";
                })(),
              }
            : {}),
          ...(showActionsColumn && {
            Actions: (
              <SoftBox display="flex" justifyContent="center" gap="8px">
                {canEdit && (
                  <IconButton
                    disabled={isInactive}
                    onClick={() => handleEditConcierge(concierge)}
                    sx={{
                      border: "1px solid #D0D5DD",
                      backgroundColor: "#F9FAFB",
                      width: 34,
                      height: 34,
                      "& svg": { fontSize: 18 },
                      color: "#475467",
                      "&:hover": {
                        backgroundColor: "#E0F2FE",
                        borderColor: "#38BDF8",
                        color: "#0284C7",
                      },
                    }}
                  >
                    <EditIcon fontSize="sm" />
                  </IconButton>
                )}

                {canRemove && (
                  <IconButton
                    onClick={() => {
                      setDeletePopupOpen(true);
                      setSelectedConcierge(concierge);
                    }}
                    disabled={isInactive}
                    sx={{
                      border: "1px solid #FECACA",
                      backgroundColor: "#FEF2F2",
                      width: 34,
                      height: 34,
                      "& svg": { fontSize: 18 },
                      color: "#B91C1C",
                      "&:hover": {
                        backgroundColor: "#FEE2E2",
                        borderColor: "#F87171",
                        color: "#991B1B",
                      },
                    }}
                  >
                    <DeleteIcon fontSize="sm" />
                  </IconButton>
                )}
              </SoftBox>
            ),
          }),
        };
      })}
    >
      {/* EDIT POPUP */}
      {isEditPopupOpen && (
        <EditFormPopup
          mode="edit"
          user={selectedConcierge}
          onClose={() => {
            setIsEditPopupOpen(false);
            fetchConcierge();
          }}
        />
      )}
      {/* ADD POPUP */}
      {isAddPopupOpen && (
        <AdminConciergeAddToProperty
          onClose={() => setIsAddPopupOpen(false)}
          refreshData={fetchConcierge}
          orgIdForProperties={orgId || currentOrgId}
          current_user_role_id={current_user_role_id}
        />
      )}

      <MultiConfirmDialog
        open={confirmDialog.open}
        type={confirmDialog.type}
        title={confirmDialog.type === "delete" ? "Delete Concierge" : "Restore Concierge"}
        description={
          confirmDialog.type === "delete"
            ? "This will permanently delete the concierge. This action cannot be undone."
            : "Are you sure you want to restore this concierge?"
        }
        confirmText={confirmDialog.type === "delete" ? "Delete Permanently" : "Restore"}
        onClose={() => setConfirmDialog({ open: false, type: null, concierge: null, property: null })}
        onConfirm={handleConfirmAction}
        assignments={confirmDialog.concierge?.user_property || []}
        parentMap={propertyMap}
        idKey="property_id"
        entityLabel="Property"
      />

      {/* {deletePopupOpen && (
        <DeleteForm
          data={selectedConcierge}
          onClose={() => setDeletePopupOpen(false)}
          onDelete={() => {
            handleDeleteConcierge(selectedConcierge);
            setDeletePopupOpen(false);
          }}
        />
      )} */}

      {deletePopupOpen && (
        <RemoveFromParentForm
          open={deletePopupOpen}
          entity={selectedConcierge}
          entityLabel="Concierge"
          parentLabel="Property"
          assignments={selectedConcierge?.user_property}
          parentKey="property_id"
          parentMap={propertyMap}
          onClose={() => setDeletePopupOpen(false)}
          onRemove={(property_id, user) => {
            handleDeleteConcierge({
              property_id,
              user_id: user.id,
              user_role_id: 4,
              organization_id: orgId || currentOrgId,
            });
            setDeletePopupOpen(false);
          }}
        />
      )}

      <Menu
        anchorEl={propertyFilterAnchor}
        open={Boolean(propertyFilterAnchor)}
        onClose={() => setPropertyFilterAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {/* Header */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          px={1}
          py={1}
          gap={1}
        >
          <SoftInput
            placeholder="Search property"
            size="small"
            value={propertySearch}
            onChange={(e) => setPropertySearch(e.target.value)}
          />

          <IconButton
            size="small"
            onClick={() => {
              setPropertyFilterAnchor(null);
              setPropertySearch("");
            }}
          >
            ✕
          </IconButton>
        </Box>

        {/* Clear */}
        {selectedProperties.length > 0 && (
          <MenuItem
            onClick={() => setSelectedProperties([])}
            sx={{ color: "#0284C7", fontWeight: 600 }}
          >
            Clear Selection
          </MenuItem>
        )}

        {/* Property List */}
        {filteredPropertyList.length > 0 ? (
          filteredPropertyList.map((p) => (
            <MenuItem
              key={p.id}
              onClick={() => {
                if (selectedProperties.includes(p.id)) {
                  setSelectedProperties(selectedProperties.filter((id) => id !== p.id));
                } else {
                  setSelectedProperties([...selectedProperties, p.id]);
                }
              }}
            >
              <Checkbox checked={selectedProperties.includes(p.id)} />
              <ListItemText primary={p.name} primaryTypographyProps={{ variant: "body3" }} />
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No properties found</MenuItem>
        )}
      </Menu>
    </SmartTableCard>
  );
}

export default AdminConcierge;